module.exports = __webpack_public_path__ + "static/media/remaining_debt.2ab17a63.svg";